
import { useLocation } from "react-router-dom";
import "../../src/assets/css/ProjectCompletionCard.css";

export default function ProjectCompletionCard({ formData, logo, coverImages, categories }) {
  const location = useLocation();

  const isFieldCompleted = (fieldName) => {
    switch (fieldName) {
      case "Project name":
        return formData?.name && formData.name.trim() !== "";
      case "Project URL":
        return formData?.url && formData.url.trim() !== "";
      case "Tagline":
        return formData?.tagline && formData.tagline.trim() !== "";
      case "Category(ies)":
        return formData?.category_ids && formData.category_ids.length > 0;
      case "collaborators":
        return formData?.collaborators && formData.collaborators.trim() !== "";
      case "Tech Stack":
        return formData?.tech_stack && formData.tech_stack.trim() !== "";
      case "Description":
        return formData?.description && formData.description.trim() !== "";
      case "Logo":
        return logo !== null;
      case "Cover image(s)":
        return coverImages && coverImages.length > 0;
      case "Features":
        return formData?.features && formData.features.trim() !== "";
      case "Benefits":
        return formData?.benefits && formData.benefits.trim() !== "";
      default:
        return false;
    }
  };

  const checklist = [
    { label: "Project name", completed: isFieldCompleted("Project name") },
    { label: "Project URL", completed: isFieldCompleted("Project URL") },
    { label: "Tagline", completed: isFieldCompleted("Tagline") },
    { label: "Category(ies)", completed: isFieldCompleted("Category(ies)") },
    { label: "collaborators", completed: isFieldCompleted("collaborators") },
    { label: "Tech Stack", completed: isFieldCompleted("Tech Stack") },
    { label: "Logo", completed: isFieldCompleted("Logo") },
    { label: "Cover image(s)", completed: isFieldCompleted("Cover image(s)") },
    { label: "Features", completed: isFieldCompleted("Features") },
    { label: "Benefits", completed: isFieldCompleted("Benefits") },
    { label: "Description", completed: isFieldCompleted("Description") },
  ];

  const completedCount = checklist.filter(item => item.completed).length;
  const totalCount = checklist.length;
  const completionPercentage = Math.round((completedCount / totalCount) * 100);

  const getProgressBarColor = (percentage) => {
    if (percentage === 100) return '#10B981';
    if (percentage >= 70) return '#F59E0B';
    if (percentage >= 40) return '#EF4444';
    return '#EF4444';
  };

  return (
    <>
     <div className="wrapper">
      <div
        className={`completion-card ${completionPercentage === 100 ? '' : ''}`}
      >
        <h2 className="percentage">{completionPercentage}%</h2>
        <h3 className="titleproject">Project Completion</h3>
        <div 
          className="progress-bar"
        >
          <div
            className="progress-fill"
            style={{ 
              width: `${completionPercentage}%`,
              backgroundColor: getProgressBarColor(completionPercentage)
            }}
          ></div>
        </div>
        <p className="description">
          {completionPercentage === 100
            ? "🎉 Congratulations! Your project is ready for launching on LaunchBoard."
            : "Complete 100% of your project details to make it eligible for launching on LaunchBoard."
          }
        </p>
        <ul className="checklist">
          {checklist.map((item, idx) => (
            <li key={idx}>
              <span
                className={
                  item.completed ? "check-icon completed" : "check-icon incomplete"
                }
              />
              <span className={item.completed ? "check-text crossed" : "check-text"}>
                {item.label}
              </span>
            </li>
          ))}
        </ul>
      </div>
      </div>
    </>
  );
}
